import * as Icon from "@ant-design/icons";
import { Modal, Form, Row, Col, Flex } from "antd";
import Search from "antd/lib/input/Search";
import { ColumnsType } from "antd/lib/table";
import { useEffect } from "react";
import { GradePremiacaoModel } from "../../models/gradePremiacao/gradePremiacaoModel";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { buscarGradePremiacao, deletarGradePremiacao } from "../../services/gradePremiacaoService";
import { currencyBRL, formatFator } from "../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import CadastroGradePremiacao from "./modals/cadastrar";
import { setBuscaGradePremiacao, setEntityGradePremiacao, setModalCadastrarGradePremiacao, setModalDeletarGradePremiacao } from "../../redux/slices/gradePremiacao/gradePremiacaoSlice";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { ButtonComponent } from "../../components/button/cadastrar";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";

const GradePremiacao = () => {
  //estados globais
  const gradePremiacaoState = useAppSelector((state) => state.gradePremiacao);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const editar = Object.values(gradePremiacaoState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("GRADES DE PREMIAÇÃO"));
    dispatch(buscarGradePremiacao(gradePremiacaoState.busca));
    form.setFieldsValue({ pesquisar: gradePremiacaoState.busca });
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityGradePremiacao({}));
    dispatch(setModalCadastrarGradePremiacao(true));
  };

  const goEditar = (value: GradePremiacaoModel) => {
    dispatch(setEntityGradePremiacao(value));
    dispatch(setModalCadastrarGradePremiacao(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarGradePremiacao(false));
  };

  const goDeletar = (value: GradePremiacaoModel) => {
    dispatch(setEntityGradePremiacao(value));
    dispatch(setModalDeletarGradePremiacao(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarGradePremiacao(false));
  };

  const onSearch = (value: string) => {
    dispatch(setBuscaGradePremiacao(value));
    dispatch(buscarGradePremiacao(value));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<GradePremiacaoModel> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a: any, b: any) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "TOTAL LÍQUIDO",
      dataIndex: "valorTotalPremiacaoLiquido",
      align: "right",
      sorter: (a: any, b: any) => a.valorTotalPremiacaoLiquido - b.valorTotalPremiacaoLiquido,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorTotalPremiacaoLiquido),
    },
    {
      title: "TOTAL BRUTO",
      dataIndex: "valorTotalPremiacaoBruto",
      align: "right",
      sorter: (a: any, b: any) => a.valorTotalPremiacaoBruto - b.valorTotalPremiacaoBruto,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorTotalPremiacaoBruto),
    },
    {
      title: "VALOR DO TÍTULO",
      dataIndex: "valorTitulo",
      align: "right",
      sorter: (a, b) => a.valorTitulo - b.valorTitulo,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorTitulo),
    },
    {
      title: "FATOR PREMIAÇÃO",
      dataIndex: "fatorPremiacao",
      align: "right",
      sorter: (a, b) => a.fatorPremiacao - b.fatorPremiacao,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => formatFator(record.fatorPremiacao),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Denominação" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={gradePremiacaoState.list} columns={columns} loading={gradePremiacaoState.loading} />
      <Modal
        title={editar ? "EDITAR GRADE DE PREMIAÇÃO" : "NOVA GRADE DE PREMIAÇÃO"}
        centered
        width={950}
        open={gradePremiacaoState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroGradePremiacao />
      </Modal>
      <Modal title={"REMOVER GRADE DE PREMIAÇÃO"} centered width={350} open={gradePremiacaoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover a grade de premiação?"
          action={deletarGradePremiacao({ value: gradePremiacaoState.entity.id, busca: gradePremiacaoState.busca })}
          close={setModalDeletarGradePremiacao(false)}
        />
      </Modal>
    </Flex>
  );
};

export default GradePremiacao;
